import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import PageError from "./PageError";
interface Props {
  children: ReactNode;
}
export const ErrorBoundary = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ReactErrorBoundary FallbackComponent={_temp}>{children}</ReactErrorBoundary>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp() {
  return <PageError />;
}